import api, { getToken } from './api';

/**
 * Ré-abonnement push automatique au démarrage.
 *
 * POURQUOI : le boot-cleanup (index.html) désinscrit le Service Worker à chaque bump de
 * version. Or désinscrire le SW DÉTRUIT l'abonnement Web Push lié. Comme on déploie souvent,
 * les abonnements de toute l'équipe meurent à chaque release → les notifs « à publier
 * manuellement » ne partent plus sur les téléphones. Ici, à chaque chargement, si la
 * permission est DÉJÀ accordée et qu'aucun abonnement n'existe, on le recrée silencieusement.
 *
 * Ne demande JAMAIS la permission (silencieux) et ne fait rien si l'utilisateur n'est pas
 * connecté (POST /push/subscribe est authentifié).
 */
export async function pushAutoResubscribe(): Promise<void> {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return;
    if (Notification.permission !== 'granted') return; // jamais de prompt ici
    if (!getToken()) return; // pas connecté → l'abonnement échouerait (401)

    const registration = await navigator.serviceWorker.ready;
    const existing = await registration.pushManager.getSubscription();
    if (existing) return; // déjà abonné → rien à faire

    // Abonnement détruit (SW désinscrit au dernier déploiement) → on le recrée.
    const { data } = await api.get('/push/vapid-key');
    const publicKey: string | undefined = data?.publicKey;
    if (!publicKey) return;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });

    const sub = subscription.toJSON();
    await api.post('/push/subscribe', {
      endpoint: sub.endpoint,
      keys: { p256dh: sub.keys?.p256dh, auth: sub.keys?.auth },
    });
    // eslint-disable-next-line no-console
    console.log('[push] ré-abonnement automatique OK');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[push] ré-abonnement auto échoué', e);
  }
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
